import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B2A9CF60-30E4-46DC-9116-ED206912B156
 * name monitor-cellphone
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-cellphone.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MonitorCellphoneIcon = createSvgIcon(<><path d="M23,11H18A1,1 0 0,0 17,12V21A1,1 0 0,0 18,22H23A1,1 0 0,0 24,21V12A1,1 0 0,0 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16A2,2 0 0,0 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2Z" /></>, 'MonitorCellphoneIcon');
export default MonitorCellphoneIcon